import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  Typography,
} from '@mui/material';
import Scrollbar from 'src/components/scrollbar';
import { TableNoData } from 'src/components/table';

const IncomeStatementTableSheet = ({ data = [], title }) => {
  console.log('\ud83d\ude80 ~ IncomeStatementTableSheet ~ data:', data);
  const headers = ['Period', 'Account', 'Total Amount'];

  const hasMoreThan1 = data.some(item => 
    (item.details.expenses?.length > 1) || (item.details.revenues?.length > 1 || item.details.others?.length > 1)
  );

  const renderSection = (sectionName, displayName, periodData) => {
    const sectionData = periodData.details[sectionName] || [];
    if (sectionData.length === 0) return null;

    return (
      <>
        <TableRow>
          <TableCell
            colSpan={headers.length}
            sx={{
              fontWeight: 'bold',
              textAlign: 'start',
            }}
          >
            {displayName} ({periodData.period})
          </TableCell>
        </TableRow>

        {sectionData.map((entity, idx) => (
          <TableRow key={idx}>
            <TableCell>{periodData.period}</TableCell>
            <TableCell
              sx={{
                minWidth: '150px',
                wordBreak: 'break-word',
              }}
            >
              {entity.account_name || '-'}
            </TableCell>
            <TableCell
              sx={{
                textAlign: 'start',
                minWidth: '150px',
                wordBreak: 'break-word',
              }}
            >
              {entity.total_amount ? `$${parseFloat(entity.total_amount).toLocaleString()}` : '-'}
            </TableCell>
          </TableRow>
        ))}

        <TableRow>
          <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
            Total {displayName}
          </TableCell>
          <TableCell
            colSpan={1}
            sx={{
              fontWeight: 'bold',
              textAlign: 'start',
              backgroundColor: '#f5f5f5',
            }}
          ></TableCell>
          <TableCell
            colSpan={2}
            sx={{
              fontWeight: 'bold',
              textAlign: 'start',
              backgroundColor: '#f5f5f5',
            }}
          >
            {`$${sectionData
              .reduce((sum, item) => sum + (item.total_amount || 0), 0)
              .toLocaleString()}`}
          </TableCell>
        </TableRow>
      </>
    );
  };

  return (
    <>
      {title && (
        <Typography variant="h5" sx={{ p: 2 }}>
          {title}
        </Typography>
      )}
      <Card sx={{ boxShadow: '0px 0px 30px 0px #64748B1A' }}>
        <TableContainer component={Paper}>
          <Scrollbar>
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontWeight: 'bold',
                        minWidth: '120px',
                        textAlign: 'start',
                        wordBreak: 'break-word',
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((periodData, index) => (
                  <>
                    {renderSection('revenue', 'Revenue', periodData)}
                    {renderSection('expenses', 'Expenses', periodData)}
                    {renderSection('others', 'Other Income', periodData)}
                  </>
                ))}
                <TableNoData notFound={!hasMoreThan1} />
              </TableBody>
            </Table>
          </Scrollbar>
        </TableContainer>
      </Card>
    </>
  );
};

export default IncomeStatementTableSheet;
